import { useQuery } from "@tanstack/react-query";
import { fetchBoards } from "@api/boards";

//메인에 노출되는 TOP 5 공지사항
const fetchNoticeList = async () => {
  const body = {
    modes: "List",
    boardName: "notice",
  };
  const res = await fetchBoards(body);
  if (res.code === "0000") {
    return res.data.data.slice(0, 5);
  }
  return [];
};

export const useNoticeListQuery = () => {
  return useQuery({
    queryKey: ["noticeList"],
    queryFn: fetchNoticeList,
  });
};
